import React, { useEffect, useState } from 'react';
import api from '../services/api';

const LIMIT = 20;

const Clientes: React.FC = () => {
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  const esAdmin = usuario.rol === 'gerente' || usuario.rol === 'administrador';
  const esGerente = usuario.rol === 'gerente';
  const [clientes, setClientes] = useState<any[]>([]);
  const [paquetes, setPaquetes] = useState<any[]>([]);
  const [instalaciones, setInstalaciones] = useState<any[]>([]);
  const [usuarios, setUsuarios] = useState<any[]>([]);
  const cobradores = usuarios.filter(u => u.rol === 'cobrador');
  const [filtroCobrador, setFiltroCobrador] = useState('');
  const [seleccionMode, setSeleccionMode] = useState(false);
  const [seleccionados, setSeleccionados] = useState<Set<string>>(new Set());
  const [asignarA, setAsignarA] = useState('');
  const [asignando, setAsignando] = useState(false);
  const [stats, setStats] = useState({ total: 0, activos: 0, cortados: 0 });
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalClientes, setTotalClientes] = useState(0);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState<any>(null);
  const [busquedaInput, setBusquedaInput] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const [detalle, setDetalle] = useState<any>(null);
  const [lightbox, setLightbox] = useState<string | null>(null);
  const [eliminando, setEliminando] = useState<string | null>(null);
  const [buscandoDni, setBuscandoDni] = useState(false);
  const [esClienteAntiguo, setEsClienteAntiguo] = useState(false);
  const [mesesDeuda, setMesesDeuda] = useState(0);
  const [mesesDeudaInicial, setMesesDeudaInicial] = useState(0);
  const [exportando, setExportando] = useState(false);
  const [form, setForm] = useState({
    nombres: '', apellidos: '', dni: '', telefono: '', telefono2: '',
    direccion: '', paqueteId: '', instalacionId: '', cobradorId: '',
    fechaInicio: new Date().toISOString().split('T')[0],
    lat: '', lng: '', fotoCasaUrl: '', fotoClienteUrl: '', zona: ''
  });

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await api.get('/clientes', { params: { page, limit: LIMIT, q: busqueda || undefined, cobradorId: filtroCobrador || undefined } });
      setClientes(res.data.data);
      setTotalPages(res.data.totalPages);
      setTotalClientes(res.data.total);
    } catch {}
    finally { setLoading(false); }
  };

  const cargarStats = async () => {
    try { setStats((await api.get('/clientes/stats', { params: { cobradorId: filtroCobrador || undefined } })).data); } catch {}
  };

  const cargarAuxiliares = async () => {
    try {
      const [paqRes, instRes] = await Promise.all([
        api.get('/paquetes/activos'),
        api.get('/instalaciones'),
      ]);
      setPaquetes(paqRes.data);
      setInstalaciones(instRes.data.filter((i: any) => i.activo));
    } catch {}
    if (esAdmin) {
      try {
        const usrRes = await api.get('/usuarios');
        setUsuarios((usrRes.data as any[]).filter(u => u.activo));
      } catch {}
    }
  };

  useEffect(() => { cargarAuxiliares(); }, []);
  useEffect(() => { cargar(); }, [page, busqueda, filtroCobrador]);
  useEffect(() => { cargarStats(); }, [filtroCobrador]);

  // Debounce de busqueda: espera a que el usuario deje de escribir antes de golpear al backend
  useEffect(() => {
    const t = setTimeout(() => { setPage(1); setBusqueda(busquedaInput); }, 400);
    return () => clearTimeout(t);
  }, [busquedaInput]);

  const calcularProporcional = () => {
    if (!form.paqueteId || !form.fechaInicio || esClienteAntiguo) return null;
    const paq = paquetes.find(p => p.id === form.paqueteId);
    if (!paq) return null;
    const fecha = new Date(form.fechaInicio + 'T12:00:00');
    const diaInicio = fecha.getDate();
    if (diaInicio === 1) return null;
    const ultimoDia = new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0).getDate();
    // +1 porque el dia de inicio tambien se cobra (debe coincidir con clientes.service.ts backend)
    const diasRestantes = ultimoDia - diaInicio + 1;
    const monto = (Number(paq.precio) / ultimoDia) * diasRestantes;
    return { monto, diasRestantes, ultimoDia, precioTotal: Number(paq.precio) };
  };

  const abrirModal = async (c?: any) => {
    setEsClienteAntiguo(false);
    setMesesDeuda(0);
    setMesesDeudaInicial(0);
    let cliente = c;
    if (c?.id) {
      try {
        const res = await api.get(`/clientes/${c.id}`);
        cliente = res.data;
      } catch {}
      try {
        const facturasRes = await api.get(`/facturas/cliente/${c.id}`);
        const mesesActuales = (facturasRes.data as any[]).filter(f => f.descripcion?.includes('deuda anterior')).length;
        if (mesesActuales > 0) {
          setEsClienteAntiguo(true);
          setMesesDeuda(mesesActuales);
          setMesesDeudaInicial(mesesActuales);
        }
      } catch {}
    }
    setEditando(cliente || null);
    setForm(cliente ? {
      nombres: cliente.nombres, apellidos: cliente.apellidos, dni: cliente.dni || '',
      telefono: cliente.telefono || '', telefono2: cliente.telefono2 || '',
      direccion: cliente.direccion || '',
      paqueteId: cliente.paqueteId || '', instalacionId: '', cobradorId: cliente.cobradorId || '',
      fechaInicio: cliente.fechaInicio?.split('T')[0] || new Date().toISOString().split('T')[0],
      lat: cliente.lat || '', lng: cliente.lng || '', fotoCasaUrl: cliente.fotoCasaUrl || '', fotoClienteUrl: cliente.fotoClienteUrl || '', zona: cliente.zona || ''
    } : {
      nombres: '', apellidos: '', dni: '', telefono: '', telefono2: '',
      direccion: '', paqueteId: '', instalacionId: '', cobradorId: '',
      fechaInicio: new Date().toISOString().split('T')[0],
      lat: '', lng: '', fotoCasaUrl: '', fotoClienteUrl: '', zona: ''
    });
    setModal(true);
  };

  const handleFoto = (e: React.ChangeEvent<HTMLInputElement>, tipo: 'casa' | 'cliente') => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setForm(f => ({ ...f, [tipo === 'casa' ? 'fotoCasaUrl' : 'fotoClienteUrl']: reader.result as string }));
    reader.readAsDataURL(file);
  };

  const guardar = async () => {
    try {
      let clienteId: string;
      // paqueteId/instalacionId/lat/lng son columnas uuid/decimal en la BD:
      // un string vacio rompe la query, asi que se omiten en vez de mandarlos como ''
      const payload: any = { ...form };
      if (!payload.paqueteId) delete payload.paqueteId;
      if (!payload.instalacionId) delete payload.instalacionId;
      // Solo el gerente asigna cobrador desde el formulario; para los demas roles
      // se ignora y el backend lo deja a nombre de quien registra (comportamiento previo).
      if (!esGerente || !payload.cobradorId) delete payload.cobradorId;
      if (!payload.lat) delete payload.lat;
      if (!payload.lng) delete payload.lng;
      if (!payload.fotoCasaUrl) delete payload.fotoCasaUrl;
      if (!payload.fotoClienteUrl) delete payload.fotoClienteUrl;
      // "Cliente antiguo" = ya tenia el servicio antes de entrar al sistema:
      // se le cobra el mes en curso completo, no prorrateado (solo aplica al crear).
      if (!editando) payload.skipFacturaInicial = esClienteAntiguo;
      if (editando) {
        await api.put(`/clientes/${editando.id}`, payload);
        clienteId = editando.id;
      } else {
        try {
          const res = await api.post('/clientes', payload);
          clienteId = res.data.id;
        } catch (err: any) {
          const clienteExistente = err?.response?.data?.cliente;
          if (err?.response?.status === 409 && clienteExistente) {
            const confirmar = window.confirm(
              `Ya existe un cliente con ese DNI: ${clienteExistente.nombres} ${clienteExistente.apellidos} (${clienteExistente.codigo}).\n\n` +
              `¿Es una segunda conexión de la misma persona? Se registrará como cliente independiente.`
            );
            if (!confirmar) return;
            const res = await api.post('/clientes', { ...payload, confirmarDuplicado: true });
            clienteId = res.data.id;
          } else {
            throw err;
          }
        }
      }
      // mesesDeuda es el TOTAL de meses de deuda que debe tener el cliente, no un
      // agregado: solo se le pide al backend la DIFERENCIA contra lo que ya tenia
      // al abrir el modal (subir genera facturas nuevas, bajar las elimina).
      let mensajeDeuda = '';
      const delta = mesesDeuda - mesesDeudaInicial;
      if (delta > 0) {
        const res = await api.post(`/clientes/${clienteId}/deuda-historica`, { meses: delta });
        const { mesesGenerados, mesesSolicitados } = res.data;
        mensajeDeuda = mesesGenerados >= mesesSolicitados
          ? `\n\nSe agregaron ${mesesGenerados} mes(es) de deuda nueva (total: ${mesesDeuda}).`
          : `\n\nSolo se pudieron agregar ${mesesGenerados} de ${mesesSolicitados} mes(es) nuevos (se llegó al límite de meses hacia atrás sin encontrar más espacio).`;
      } else if (delta < 0 && window.confirm(`Esto va a ELIMINAR ${-delta} mes(es) de deuda que ya estaban registrados (los más antiguos primero). Las facturas que ya tengan un pago no se tocan. ¿Confirmas?`)) {
        const res = await api.delete(`/clientes/${clienteId}/deuda-historica`, { params: { meses: -delta } });
        const { eliminadas, bloqueadas } = res.data;
        mensajeDeuda = bloqueadas > 0
          ? `\n\nSe eliminaron ${eliminadas} mes(es) de deuda. ${bloqueadas} no se pudieron quitar porque ya tienen un pago registrado (total real: ${mesesDeudaInicial - eliminadas}).`
          : `\n\nSe eliminaron ${eliminadas} mes(es) de deuda (total: ${mesesDeudaInicial - eliminadas}).`;
      }
      setModal(false); cargar(); cargarStats();
      if (mensajeDeuda) alert('Cliente guardado.' + mensajeDeuda);
    } catch { alert('Error al guardar'); }
  };

  const waHref = (tel?: string) => {
    const raw = (tel || '').replace(/\D/g, '');
    if (!raw) return null;
    return `https://wa.me/${raw.length === 9 ? '51' + raw : raw}`;
  };

  const eliminar = async (id: string) => {
    if (!window.confirm('Eliminar este cliente?')) return;
    setEliminando(id);
    try { await api.delete(`/clientes/${id}`); cargar(); cargarStats(); }
    catch (e: any) { alert(e?.response?.data?.message || 'Error al eliminar'); }
    finally { setEliminando(null); }
  };

  // ─── Selección múltiple + asignar cobrador (solo gerente) ──────────────────
  const toggleSeleccion = (id: string) => {
    setSeleccionados(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const todosEnPagina = clientes.length > 0 && clientes.every(c => seleccionados.has(c.id));
  const toggleSeleccionPagina = () => {
    setSeleccionados(prev => {
      const next = new Set(prev);
      if (todosEnPagina) clientes.forEach(c => next.delete(c.id));
      else clientes.forEach(c => next.add(c.id));
      return next;
    });
  };

  const salirSeleccion = () => { setSeleccionMode(false); setSeleccionados(new Set()); setAsignarA(''); };

  const asignarCobrador = async () => {
    if (!asignarA || seleccionados.size === 0) return;
    const cob = cobradores.find(c => c.id === asignarA);
    if (!window.confirm(`Asignar ${seleccionados.size} cliente(s) a ${cob?.nombre} ${cob?.apellido}?`)) return;
    setAsignando(true);
    try {
      const res = await api.put('/clientes/asignar-cobrador', {
        clienteIds: Array.from(seleccionados),
        cobradorId: asignarA,
      });
      alert(`${res.data.actualizados} cliente(s) asignado(s) a ${res.data.cobrador.nombre} ${res.data.cobrador.apellido}.`);
      salirSeleccion();
      cargar();
    } catch (e: any) {
      alert(e?.response?.data?.message || 'Error al asignar');
    } finally { setAsignando(false); }
  };

  const consultarDni = async (dni: string) => {
    if (dni.length !== 8) return;
    setBuscandoDni(true);
    try {
      const res = await api.get(`/clientes/consultar-dni/${dni}`);
      if (!res.data.noEncontrado) {
        setForm(f => ({ ...f, nombres: res.data.nombres, apellidos: res.data.apellidos }));
      }
    } catch {}
    finally { setBuscandoDni(false); }
  };

  const colorEstado = (e: string) => e === 'activo' ? '#22c55e' : e === 'cortado' ? '#ef4444' : '#f59e0b';

  const proporcional = calcularProporcional();

  // ─── Importar CSV ─────────────────────────────────────────────────────────
  const [importModal, setImportModal] = useState(false);
  const [importPreview, setImportPreview] = useState<any[]>([]);
  const [importando, setImportando] = useState(false);
  const [importResult, setImportResult] = useState<any>(null);

  const parsearCSV = (texto: string): any[] => {
    const lineas = texto.trim().split('\n').filter(l => l.trim());
    if (lineas.length < 2) return [];
    const encabezados = lineas[0].split(',').map(h => h.trim().replace(/^"|"$/g, '').toLowerCase());
    return lineas.slice(1).map(linea => {
      const valores = linea.match(/("([^"]*)"|[^,]+|(?<=,)(?=,)|^(?=,)|(?<=,)$)/g) || [];
      const obj: any = {};
      encabezados.forEach((h, i) => {
        obj[h] = (valores[i] || '').trim().replace(/^"|"$/g, '');
      });
      return obj;
    });
  };

  const handleImportFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const texto = ev.target?.result as string;
      const filas = parsearCSV(texto);
      setImportPreview(filas.slice(0, 10));
      setImportModal(true);
      setImportResult(null);
    };
    reader.readAsText(file, 'UTF-8');
    e.target.value = '';
  };

  const ejecutarImport = async () => {
    if (importPreview.length === 0) return;
    setImportando(true);
    try {
      const res = await api.post('/clientes/importar-bulk', { registros: importPreview });
      setImportResult(res.data);
      cargar(); cargarStats();
    } catch { alert('Error al importar'); }
    finally { setImportando(false); }
  };

  const exportarCSV = async () => {
    setExportando(true);
    try {
      const res = await api.get('/clientes', { params: { limit: 5000, q: busqueda || undefined, cobradorId: filtroCobrador || undefined } });
      const todos = res.data.data as any[];
      const rows = [
        ['Codigo','Nombres','Apellidos','DNI','Telefono','Direccion','Zona','Paquete','Estado','Cobrador'],
        ...todos.map(c => [
          c.codigo || '',
          c.nombres || '',
          c.apellidos || '',
          c.dni || '',
          c.telefono || '',
          c.direccion || '',
          c.zona || '',
          c.paquete?.nombre || '',
          c.estado || '',
          `${c.cobrador?.nombre || ''} ${c.cobrador?.apellido || ''}`.trim(),
        ])
      ];
      const csv = '﻿' + rows.map(r => r.map(c => `"${String(c).replace(/"/g,'""')}"`).join(',')).join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `clientes-${new Date().toISOString().split('T')[0]}.csv`; a.click();
      URL.revokeObjectURL(url);
    } catch { alert('Error al exportar'); }
    finally { setExportando(false); }
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h2 style={{ color:'#f1f5f9', margin:0, fontSize:24, fontWeight:800 }}>Clientes</h2>
          <p style={{ color:'#64748b', margin:'4px 0 0', fontSize:13 }}>Gestion de clientes del servicio de agua</p>
        </div>
        <div style={{ display:'flex', gap:10 }}>
          <label style={{ background:'#0f172a', border:'1px solid #22c55e44', color:'#22c55e', padding:'10px 16px', borderRadius:10, cursor:'pointer', fontWeight:600, fontSize:13 }}>
            📤 Importar CSV
            <input type="file" accept=".csv" onChange={handleImportFile} style={{ display:'none' }} />
          </label>
          <button onClick={exportarCSV} disabled={exportando}
            style={{ background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', padding:'10px 16px', borderRadius:10, cursor:'pointer', fontWeight:600, fontSize:13, opacity: exportando ? 0.7 : 1 }}>
            {exportando ? 'Exportando...' : '📥 Exportar CSV'}
          </button>
          {esGerente && (
            <button onClick={() => (seleccionMode ? salirSeleccion() : setSeleccionMode(true))}
              style={{ background: seleccionMode ? '#8b5cf6' : '#0f172a', border:'1px solid #8b5cf644', color: seleccionMode ? 'white' : '#a78bfa', padding:'10px 16px', borderRadius:10, cursor:'pointer', fontWeight:600, fontSize:13 }}>
              {seleccionMode ? 'Cancelar' : '☑️ Seleccionar'}
            </button>
          )}
          <button onClick={() => abrirModal()}
            style={{ background:'#0ea5e9', border:'none', color:'white', padding:'10px 20px', borderRadius:10, cursor:'pointer', fontWeight:700, fontSize:14 }}>
            + Nuevo Cliente
          </button>
        </div>
      </div>

      {seleccionMode && (
        <div style={{ display:'flex', alignItems:'center', gap:12, flexWrap:'wrap', background:'#1e293b', border:'1px solid #8b5cf644', borderRadius:10, padding:'12px 16px', marginBottom:16 }}>
          <span style={{ color:'#a78bfa', fontWeight:700, fontSize:13 }}>{seleccionados.size} seleccionado(s)</span>
          <select value={asignarA} onChange={e => setAsignarA(e.target.value)}
            style={{ background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'8px 12px', color:'white', fontSize:13, minWidth:220 }}>
            <option value="">Asignar a cobrador…</option>
            {cobradores.map(c => <option key={c.id} value={c.id}>{c.nombre} {c.apellido}</option>)}
          </select>
          <button onClick={asignarCobrador} disabled={asignando || !asignarA || seleccionados.size === 0}
            style={{ background: (!asignarA || seleccionados.size === 0) ? '#334155' : '#8b5cf6', border:'none', color:'white', padding:'8px 18px', borderRadius:8, cursor:'pointer', fontWeight:700, fontSize:13, opacity: asignando ? 0.7 : 1 }}>
            {asignando ? 'Asignando…' : `Asignar (${seleccionados.size})`}
          </button>
        </div>
      )}

      <div style={{ display:'flex', gap:10, marginBottom:20, flexWrap:'wrap' }}>
        <input value={busquedaInput} onChange={e => setBusquedaInput(e.target.value)}
          placeholder="Buscar por nombre, apellido, DNI o telefono..."
          style={{ flex:1, minWidth:220, background:'#1e293b', border:'1px solid #334155', borderRadius:10, padding:'10px 16px', color:'white', fontSize:14, boxSizing:'border-box' }} />
        {esAdmin && (
          <select value={filtroCobrador} onChange={e => { setPage(1); setFiltroCobrador(e.target.value); }}
            style={{ minWidth:200, background:'#1e293b', border:`1px solid ${filtroCobrador ? '#8b5cf6' : '#334155'}`, borderRadius:10, padding:'10px 14px', color:'white', fontSize:14 }}>
            <option value="">Todos los usuarios</option>
            {usuarios.map(u => <option key={u.id} value={u.id}>{u.nombre} {u.apellido} · {u.rol}</option>)}
          </select>
        )}
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
        {[
          { label:'Total', value: stats.total, color:'#38bdf8' },
          { label:'Activos', value: stats.activos, color:'#22c55e' },
          { label:'Cortados', value: stats.cortados, color:'#ef4444' },
        ].map(s => (
          <div key={s.label} style={{ background:'#1e293b', borderRadius:10, padding:'14px 18px', border:`1px solid ${s.color}33` }}>
            <div style={{ color:'#64748b', fontSize:12 }}>{s.label}</div>
            <div style={{ color:s.color, fontSize:24, fontWeight:800 }}>{s.value}</div>
          </div>
        ))}
      </div>

      {loading ? <div style={{ color:'#64748b', textAlign:'center', padding:48 }}>Cargando...</div> :
        <div style={{ background:'#1e293b', borderRadius:12, overflow:'hidden', border:'1px solid #334155' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr style={{ background:'#0f172a' }}>
                {seleccionMode && (
                  <th style={{ padding:'12px 16px', borderBottom:'1px solid #334155', width:40 }}>
                    <input type="checkbox" checked={todosEnPagina} onChange={toggleSeleccionPagina} style={{ cursor:'pointer' }} />
                  </th>
                )}
                {['Codigo','Cliente','DNI','Teléfonos','Paquete','Estado', ...(esAdmin ? ['Cobrador'] : []), 'Acciones'].map(h => (
                  <th key={h} style={{ padding:'12px 16px', color:'#64748b', fontSize:12, fontWeight:600, textAlign:'left', borderBottom:'1px solid #334155' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {clientes.map((c, i) => {
                const mesesDeuda = c.mesesDeuda || 0;
                return (
                  <tr key={c.id} onClick={seleccionMode ? () => toggleSeleccion(c.id) : undefined}
                    style={{ borderBottom:'1px solid #0f172a', cursor: seleccionMode ? 'pointer' : 'default', background: seleccionados.has(c.id) ? '#8b5cf618' : mesesDeuda >= 2 ? '#ef444408' : i % 2 === 0 ? 'transparent' : '#0f172a11' }}>
                    {seleccionMode && (
                      <td style={{ padding:'12px 16px' }} onClick={e => e.stopPropagation()}>
                        <input type="checkbox" checked={seleccionados.has(c.id)} onChange={() => toggleSeleccion(c.id)} style={{ cursor:'pointer' }} />
                      </td>
                    )}
                    <td style={{ padding:'12px 16px', color:'#38bdf8', fontSize:13, fontWeight:600 }}>{c.codigo}</td>
                    <td style={{ padding:'12px 16px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        {c.fotoClienteUrl ? (
                          <img src={c.fotoClienteUrl} alt=""
                            onClick={e => { e.stopPropagation(); setLightbox(c.fotoClienteUrl); }}
                            style={{ width:36, height:36, borderRadius:'50%', objectFit:'cover', border:'1px solid #334155', cursor:'zoom-in', flexShrink:0 }} />
                        ) : (
                          <div style={{ width:36, height:36, borderRadius:'50%', background:'#0f172a', border:'1px solid #334155', display:'flex', alignItems:'center', justifyContent:'center', color:'#475569', fontSize:16, flexShrink:0 }}>
                            {(c.nombres?.[0] || '?').toUpperCase()}
                          </div>
                        )}
                        <div>
                          <div style={{ color:'#f1f5f9', fontWeight:600 }}>{c.apellidos}, {c.nombres}</div>
                          <div style={{ color:'#64748b', fontSize:11 }}>{c.direccion || '—'}</div>
                        </div>
                      </div>
                    </td>
                    <td style={{ padding:'12px 16px', color:'#94a3b8', fontSize:13 }}>{c.dni || '—'}</td>
                    <td style={{ padding:'12px 16px' }} onClick={e => e.stopPropagation()}>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <span style={{ color:'#94a3b8', fontSize:13 }}>{c.telefono || '—'}</span>
                        {waHref(c.telefono) && (
                          <a href={waHref(c.telefono)!} target="_blank" rel="noreferrer" title="Abrir WhatsApp"
                            style={{ background:'#25d36622', border:'1px solid #25d36655', color:'#25d366', borderRadius:6, padding:'2px 7px', fontSize:12, textDecoration:'none', fontWeight:700 }}>
                            WhatsApp
                          </a>
                        )}
                      </div>
                      {c.telefono2 && (
                        <div style={{ display:'flex', alignItems:'center', gap:8, marginTop:2 }}>
                          <span style={{ color:'#64748b', fontSize:11 }}>{c.telefono2}</span>
                          {waHref(c.telefono2) && (
                            <a href={waHref(c.telefono2)!} target="_blank" rel="noreferrer" title="Abrir WhatsApp"
                              style={{ color:'#25d366', fontSize:10, textDecoration:'none', fontWeight:700 }}>
                              WhatsApp
                            </a>
                          )}
                        </div>
                      )}
                    </td>
                    <td style={{ padding:'12px 16px' }}>
                      <span style={{ background:'#0ea5e922', color:'#38bdf8', border:'1px solid #0ea5e944', borderRadius:20, padding:'3px 10px', fontSize:12 }}>
                        {c.paquete?.nombre || '—'}
                      </span>
                    </td>
                    <td style={{ padding:'12px 16px' }}>
                      <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                        <span style={{ background:`${colorEstado(c.estado)}22`, color:colorEstado(c.estado), border:`1px solid ${colorEstado(c.estado)}44`, borderRadius:20, padding:'3px 10px', fontSize:12, fontWeight:700, display:'inline-block' }}>
                          {c.estado}
                        </span>
                        {mesesDeuda >= 2 && (
                          <span style={{ background:'#ef444422', color:'#ef4444', border:'1px solid #ef444444', borderRadius:20, padding:'2px 8px', fontSize:10, fontWeight:700, display:'inline-block' }}>
                            {mesesDeuda} meses sin pagar
                          </span>
                        )}
                      </div>
                    </td>
                    {esAdmin && (
                      <td style={{ padding:'12px 16px', fontSize:13 }}>
                        {c.cobrador ? (
                          <span style={{ color:'#e2e8f0' }}>
                            {c.cobrador.nombre} {c.cobrador.apellido}
                            {c.cobrador.rol && c.cobrador.rol !== 'cobrador' && (
                              <span style={{ color:'#f59e0b', fontSize:11 }}> ({c.cobrador.rol})</span>
                            )}
                          </span>
                        ) : <span style={{ color:'#64748b' }}>—</span>}
                      </td>
                    )}
                    <td style={{ padding:'12px 16px' }} onClick={e => e.stopPropagation()}>
                      <div style={{ display:'flex', gap:6 }}>
                        <button onClick={() => setDetalle(c)}
                          style={{ background:'#22c55e22', border:'1px solid #22c55e44', color:'#22c55e', borderRadius:6, padding:'6px 10px', cursor:'pointer', fontSize:12, fontWeight:600 }}>
                          Ver
                        </button>
                        {esAdmin && (
                          <button onClick={() => abrirModal(c)}
                            style={{ background:'#1d4ed822', border:'1px solid #1d4ed844', color:'#60a5fa', borderRadius:6, padding:'6px 10px', cursor:'pointer', fontSize:12, fontWeight:600 }}>
                            Editar
                          </button>
                        )}
                        {esGerente && (
                          <button onClick={() => eliminar(c.id)} disabled={eliminando === c.id}
                            style={{ background:'#ef444411', border:'1px solid #ef444433', color:'#ef4444', borderRadius:6, padding:'6px 10px', cursor:'pointer', fontSize:12, fontWeight:600 }}>
                            {eliminando === c.id ? '...' : 'Eliminar'}
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {clientes.length === 0 && <div style={{ textAlign:'center', color:'#64748b', padding:32 }}>No hay clientes</div>}
        </div>
      }

      {!loading && totalClientes > 0 && (
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:16 }}>
          <span style={{ color:'#64748b', fontSize:12 }}>
            Mostrando {(page - 1) * LIMIT + 1}–{Math.min(page * LIMIT, totalClientes)} de {totalClientes} clientes
          </span>
          <div style={{ display:'flex', gap:8, alignItems:'center' }}>
            <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page <= 1}
              style={{ background:'#1e293b', border:'1px solid #334155', color: page <= 1 ? '#475569' : '#94a3b8', borderRadius:8, padding:'6px 14px', cursor: page <= 1 ? 'default' : 'pointer', fontSize:12, fontWeight:600 }}>
              ← Anterior
            </button>
            <span style={{ color:'#94a3b8', fontSize:12 }}>Página {page} de {totalPages}</span>
            <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page >= totalPages}
              style={{ background:'#1e293b', border:'1px solid #334155', color: page >= totalPages ? '#475569' : '#94a3b8', borderRadius:8, padding:'6px 14px', cursor: page >= totalPages ? 'default' : 'pointer', fontSize:12, fontWeight:600 }}>
              Siguiente →
            </button>
          </div>
        </div>
      )}

      {/* Modal detalle */}
      {detalle && (
        <div onClick={() => setDetalle(null)} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.8)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999, padding:20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background:'#1e293b', borderRadius:16, padding:24, width:560, maxHeight:'90vh', overflowY:'auto', border:'1px solid #334155' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
              <h3 style={{ color:'#f1f5f9', margin:0 }}>{detalle.nombres} {detalle.apellidos}</h3>
              <button onClick={() => setDetalle(null)} style={{ background:'none', border:'none', color:'#64748b', cursor:'pointer', fontSize:20 }}>X</button>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:16 }}>
              <div>
                <div style={{ color:'#64748b', fontSize:11, marginBottom:6 }}>Foto cliente</div>
                {detalle.fotoClienteUrl ? (
                  <img src={detalle.fotoClienteUrl} alt="cliente" onClick={() => setLightbox(detalle.fotoClienteUrl)}
                    style={{ width:'100%', height:140, objectFit:'cover', borderRadius:8, border:'1px solid #334155', cursor:'zoom-in' }} />
                ) : (
                  <div style={{ height:140, background:'#0f172a', borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center', color:'#64748b' }}>Sin foto</div>
                )}
              </div>
              <div>
                <div style={{ color:'#64748b', fontSize:11, marginBottom:6 }}>Foto casa</div>
                {detalle.fotoCasaUrl ? (
                  <img src={detalle.fotoCasaUrl} alt="casa" onClick={() => setLightbox(detalle.fotoCasaUrl)}
                    style={{ width:'100%', height:140, objectFit:'cover', borderRadius:8, border:'1px solid #334155', cursor:'zoom-in' }} />
                ) : (
                  <div style={{ height:140, background:'#0f172a', borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center', color:'#64748b' }}>Sin foto</div>
                )}
              </div>
            </div>
            <div style={{ background:'#0f172a', borderRadius:10, padding:14, marginBottom:12 }}>
              {[
                { label:'Codigo', value: detalle.codigo },
                { label:'DNI', value: detalle.dni || '—' },
                { label:'Teléfono 1', value: detalle.telefono || '—' },
                { label:'Teléfono 2', value: detalle.telefono2 || '—' },
                { label:'Direccion', value: detalle.direccion || '—' },
                { label:'Paquete', value: detalle.paquete?.nombre || '—' },
                { label:'Precio', value: detalle.paquete ? `S/. ${Number(detalle.paquete.precio).toFixed(2)}/mes` : '—' },
                { label:'Estado', value: detalle.estado },
              ].map(f => (
                <div key={f.label} style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', borderBottom:'1px solid #1e293b' }}>
                  <span style={{ color:'#64748b', fontSize:13 }}>{f.label}</span>
                  <span style={{ color:'#f1f5f9', fontSize:13, fontWeight:600 }}>{f.value}</span>
                </div>
              ))}
            </div>
            {waHref(detalle.telefono) && (
              <a href={waHref(detalle.telefono)!} target="_blank" rel="noreferrer"
                style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8, background:'#25d36611', border:'1px solid #25d36644', borderRadius:8, padding:'10px 14px', color:'#25d366', textDecoration:'none', fontWeight:700, fontSize:13, marginBottom:12 }}>
                💬 Escribir por WhatsApp {detalle.telefono}
              </a>
            )}
            {detalle.lat && detalle.lng && (
              <a href={`https://www.google.com/maps/dir/?api=1&destination=${detalle.lat},${detalle.lng}`} target="_blank" rel="noreferrer"
                style={{ display:'block', background:'#22c55e11', border:'1px solid #22c55e33', borderRadius:8, padding:'10px 14px', color:'#22c55e', textDecoration:'none', textAlign:'center', fontWeight:600, fontSize:13, marginBottom:12 }}>
                Como llegar - Google Maps
              </a>
            )}
            <div style={{ display:'flex', gap:10 }}>
              {esAdmin && (
                <button onClick={() => { setDetalle(null); abrirModal(detalle); }}
                  style={{ flex:1, background:'#0ea5e9', border:'none', color:'white', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:700 }}>
                  Editar
                </button>
              )}
              <button onClick={() => setDetalle(null)}
                style={{ flex:1, background:'#334155', border:'none', color:'#94a3b8', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:600 }}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal editar/crear */}
      {modal && (
        <div onClick={() => setModal(false)} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999, padding:20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background:'#1e293b', borderRadius:16, padding:28, width:540, maxHeight:'90vh', overflowY:'auto', border:'1px solid #334155' }}>
            <h3 style={{ color:'#f1f5f9', margin:'0 0 20px' }}>{editando ? 'Editar Cliente' : 'Nuevo Cliente'}</h3>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
              {[
                { label:'Nombres', key:'nombres', type:'text' },
                { label:'Apellidos', key:'apellidos', type:'text' },
                { label:'DNI', key:'dni', type:'text' },
                { label:'Teléfono 1 (cobrador)', key:'telefono', type:'text' },
                { label:'Teléfono 2 (cobrador)', key:'telefono2', type:'text' },
                { label:'Dirección', key:'direccion', type:'text' },
                { label:'Fecha inicio', key:'fechaInicio', type:'date' },
                { label:'Zona/Sector', key:'zona', type:'text' },
              ].map(f => (
                <div key={f.key}>
                  <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>
                    {f.label}
                    {f.key === 'dni' && buscandoDni && (
                      <span style={{ color:'#38bdf8', fontSize:11, marginLeft:8, fontWeight:400 }}>Buscando...</span>
                    )}
                  </label>
                  <input
                    value={(form as any)[f.key]}
                    onChange={e => {
                      const val = e.target.value;
                      setForm({...form, [f.key]: val});
                      if (f.key === 'dni') consultarDni(val);
                    }}
                    type={f.type}
                    maxLength={f.key === 'dni' ? 8 : undefined}
                    style={{ width:'100%', background:'#0f172a', border:`1px solid ${f.key === 'dni' && buscandoDni ? '#38bdf8' : '#334155'}`, borderRadius:8, padding:'9px 12px', color:'white', fontSize:13, boxSizing:'border-box' }} />
                </div>
              ))}
            </div>

            <div style={{ marginTop:14 }}>
              <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>Paquete mensual</label>
              <select value={form.paqueteId} onChange={e => setForm({...form, paqueteId: e.target.value})}
                style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'9px 12px', color:'white', fontSize:13 }}>
                <option value="">Seleccionar paquete</option>
                {paquetes.map(p => <option key={p.id} value={p.id}>{p.nombre} — S/. {Number(p.precio).toFixed(2)}/mes</option>)}
              </select>
            </div>

            {esGerente && (
              <div style={{ marginTop:14 }}>
                <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>Cobrador asignado</label>
                <select value={form.cobradorId} onChange={e => setForm({...form, cobradorId: e.target.value})}
                  style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'9px 12px', color:'white', fontSize:13 }}>
                  <option value="">{editando ? 'Sin cambios' : 'Yo (quien registra)'}</option>
                  {cobradores.map(c => <option key={c.id} value={c.id}>{c.nombre} {c.apellido}</option>)}
                </select>
              </div>
            )}

            {/* Cálculo proporcional primer mes */}
            {!editando && proporcional && (
              <div style={{ background:'#0ea5e911', border:'1px solid #0ea5e933', borderRadius:8, padding:'12px 14px', marginTop:10 }}>
                <div style={{ color:'#38bdf8', fontWeight:700, fontSize:13, marginBottom:4 }}>Primera factura proporcional</div>
                <div style={{ color:'#94a3b8', fontSize:12 }}>
                  Instalación en día {new Date(form.fechaInicio + 'T12:00:00').getDate()} → quedan {proporcional.diasRestantes} días del mes
                </div>
                <div style={{ color:'#38bdf8', fontSize:20, fontWeight:800, marginTop:6 }}>
                  S/. {proporcional.monto.toFixed(2)}
                  <span style={{ color:'#64748b', fontSize:12, fontWeight:400 }}> (en vez de S/. {proporcional.precioTotal.toFixed(2)})</span>
                </div>
                <div style={{ color:'#64748b', fontSize:11, marginTop:4 }}>
                  A partir del próximo mes paga S/. {proporcional.precioTotal.toFixed(2)} como todos
                </div>
              </div>
            )}
            {!editando && form.paqueteId && !proporcional && (
              <div style={{ background:'#22c55e11', border:'1px solid #22c55e33', borderRadius:8, padding:'10px 14px', marginTop:10 }}>
                <span style={{ color:'#22c55e', fontSize:12, fontWeight:600 }}>
                  Inicio el 1° del mes — factura completa: S/. {Number(paquetes.find(p=>p.id===form.paqueteId)?.precio||0).toFixed(2)}
                </span>
              </div>
            )}

            {/* Tipo de instalación (solo en creación) */}
            {!editando && (
              <div style={{ marginTop:14 }}>
                <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>Tipo de instalación (opcional)</label>
                <select value={form.instalacionId} onChange={e => setForm({...form, instalacionId: e.target.value})}
                  style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'9px 12px', color:'white', fontSize:13 }}>
                  <option value="">Sin cargo de instalación</option>
                  {instalaciones.map(i => <option key={i.id} value={i.id}>{i.nombre} — S/. {Number(i.costo).toFixed(2)}</option>)}
                </select>
                {form.instalacionId && (
                  <div style={{ background:'#f59e0b11', border:'1px solid #f59e0b33', borderRadius:8, padding:'8px 12px', marginTop:8 }}>
                    <span style={{ color:'#f59e0b', fontSize:12 }}>
                      Se generará una factura adicional de S/. {Number(instalaciones.find(i=>i.id===form.instalacionId)?.costo||0).toFixed(2)} por instalación
                    </span>
                  </div>
                )}
              </div>
            )}

            <div style={{ marginTop:14 }}>
              <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>Ubicacion GPS</label>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                <input
                  value={form.lat}
                  onChange={e => setForm(f => ({...f, lat: e.target.value}))}
                  type="number" step="any" placeholder="Latitud"
                  style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'9px 12px', color:'white', fontSize:13, boxSizing:'border-box' }} />
                <input
                  value={form.lng}
                  onChange={e => setForm(f => ({...f, lng: e.target.value}))}
                  type="number" step="any" placeholder="Longitud"
                  style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'9px 12px', color:'white', fontSize:13, boxSizing:'border-box' }} />
              </div>
              <div style={{ display:'flex', gap:8, marginTop:8 }}>
                <button type="button" onClick={() => navigator.geolocation.getCurrentPosition(pos => setForm(f => ({...f, lat: String(pos.coords.latitude), lng: String(pos.coords.longitude)})))}
                  style={{ flex:1, background:'#0ea5e911', border:'1px solid #0ea5e933', color:'#38bdf8', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:600, fontSize:13 }}>
                  Obtener ubicacion actual
                </button>
                {(form.lat || form.lng) && (
                  <button type="button" onClick={() => setForm(f => ({...f, lat:'', lng:''}))}
                    style={{ background:'none', border:'1px solid #ef444433', color:'#ef4444', cursor:'pointer', fontSize:12, borderRadius:8, padding:'0 14px' }}>Quitar</button>
                )}
              </div>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginTop:14 }}>
              <div>
                <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>Foto cliente</label>
                <input type="file" accept="image/*" onChange={e => handleFoto(e, 'cliente')} style={{ color:'#94a3b8', fontSize:12 }} />
                {form.fotoClienteUrl && <img src={form.fotoClienteUrl} alt="cliente" style={{ width:'100%', height:80, objectFit:'cover', borderRadius:6, marginTop:6 }} />}
              </div>
              <div>
                <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>Foto casa</label>
                <input type="file" accept="image/*" onChange={e => handleFoto(e, 'casa')} style={{ color:'#94a3b8', fontSize:12 }} />
                {form.fotoCasaUrl && <img src={form.fotoCasaUrl} alt="casa" style={{ width:'100%', height:80, objectFit:'cover', borderRadius:6, marginTop:6 }} />}
              </div>
            </div>
            {/* Seccion cliente antiguo (deuda anterior al sistema) */}
            <div style={{ marginTop:16, padding:14, borderRadius:12, border:`1px solid ${esClienteAntiguo ? '#f59e0b55' : '#334155'}`, background: esClienteAntiguo ? '#f59e0b0a' : '#0f172a', transition:'all 0.2s' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <div>
                  <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:14 }}>Cliente antiguo</div>
                  <div style={{ color:'#64748b', fontSize:11 }}>Existia antes del sistema</div>
                </div>
                <div
                  onClick={() => { setEsClienteAntiguo(v => !v); if (esClienteAntiguo) setMesesDeuda(0); }}
                  style={{ width:44, height:24, borderRadius:12, background: esClienteAntiguo ? '#f59e0b' : '#334155', position:'relative', cursor:'pointer', transition:'background 0.2s', flexShrink:0 }}>
                  <div style={{ position:'absolute', top:2, left: esClienteAntiguo ? 22 : 2, width:20, height:20, borderRadius:'50%', background:'white', transition:'left 0.2s' }} />
                </div>
              </div>
              {esClienteAntiguo && (
                <div style={{ marginTop:12 }}>
                  <div style={{ color:'#94a3b8', fontSize:12, fontWeight:600, marginBottom:8 }}>Meses de deuda pendiente</div>
                  <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                    <button type="button" onClick={() => setMesesDeuda(m => Math.max(0, m - 1))}
                      style={{ width:36, height:36, borderRadius:8, background:'#1e293b', border:'1px solid #334155', color:'#94a3b8', cursor:'pointer', fontSize:20, lineHeight:1, display:'flex', alignItems:'center', justifyContent:'center' }}>−</button>
                    <div style={{ flex:1, textAlign:'center' }}>
                      <span style={{ color: mesesDeuda === 0 ? '#22c55e' : 'white', fontWeight:800, fontSize:20 }}>
                        {mesesDeuda === 0 ? 'Sin deuda' : `${mesesDeuda} mes${mesesDeuda === 1 ? '' : 'es'}`}
                      </span>
                    </div>
                    <button type="button" onClick={() => setMesesDeuda(m => Math.min(24, m + 1))}
                      style={{ width:36, height:36, borderRadius:8, background:'#1e293b', border:'1px solid #334155', color:'#94a3b8', cursor:'pointer', fontSize:20, lineHeight:1, display:'flex', alignItems:'center', justifyContent:'center' }}>+</button>
                  </div>
                  <div style={{ marginTop:8, padding:'10px 12px', borderRadius:8, background: mesesDeuda === mesesDeudaInicial ? '#22c55e11' : '#f59e0b11', border:`1px solid ${mesesDeuda === mesesDeudaInicial ? '#22c55e22' : '#f59e0b22'}` }}>
                    <span style={{ color: mesesDeuda === mesesDeudaInicial ? '#22c55e' : '#f59e0b', fontSize:12 }}>
                      {mesesDeuda === mesesDeudaInicial
                        ? (mesesDeudaInicial === 0 ? 'Sin deuda registrada. Se guarda sin facturas pendientes.' : `Ya tiene ${mesesDeudaInicial} mes(es) de deuda registrados. Sin cambios.`)
                        : mesesDeuda > mesesDeudaInicial
                        ? `Ya tenía ${mesesDeudaInicial} mes(es). Se crearán ${mesesDeuda - mesesDeudaInicial} factura(s) VENCIDA nueva(s) para llegar a ${mesesDeuda} en total.`
                        : `Ya tenía ${mesesDeudaInicial} mes(es). Se eliminarán ${mesesDeudaInicial - mesesDeuda} (empezando por las más antiguas). Las que ya tengan un pago registrado no se tocan.`}
                    </span>
                  </div>
                </div>
              )}
            </div>

            <div style={{ display:'flex', gap:10, marginTop:20 }}>
              <button onClick={() => setModal(false)} style={{ flex:1, background:'#334155', border:'none', color:'#94a3b8', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:600 }}>Cancelar</button>
              <button onClick={guardar} style={{ flex:1, background:'#0ea5e9', border:'none', color:'white', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:700 }}>Guardar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal importar CSV */}
      {importModal && (
        <div style={{ position:'fixed', inset:0, background:'#000000cc', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div style={{ background:'#1e293b', borderRadius:16, padding:28, width:760, maxWidth:'95vw', maxHeight:'90vh', overflowY:'auto', border:'1px solid #334155' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
              <h3 style={{ color:'#f1f5f9', margin:0, fontSize:18, fontWeight:800 }}>Importar clientes desde CSV</h3>
              <button onClick={() => { setImportModal(false); setImportResult(null); }} style={{ background:'none', border:'none', color:'#94a3b8', cursor:'pointer', fontSize:20 }}>✕</button>
            </div>

            {!importResult ? (
              <>
                <div style={{ background:'#0f172a', borderRadius:8, padding:14, marginBottom:16, fontSize:12, color:'#94a3b8' }}>
                  <strong style={{ color:'#38bdf8' }}>Columnas esperadas en el CSV:</strong>
                  <div style={{ marginTop:6, fontFamily:'monospace', color:'#f1f5f9' }}>
                    nombres, apellidos, dni, telefono, direccion, zona, paquete, mesEuda, cobradorDni
                  </div>
                  <div style={{ marginTop:6, color:'#64748b' }}>
                    • <strong>paquete</strong>: nombre exacto del paquete (ej: "Basico") • <strong>mesesDeuda</strong>: meses de deuda histórica a generar • <strong>cobradorDni</strong>: DNI del cobrador asignado (opcional)
                  </div>
                </div>

                {importPreview.length > 0 ? (
                  <>
                    <div style={{ color:'#94a3b8', fontSize:13, marginBottom:8 }}>
                      Vista previa (primeras {importPreview.length} filas):
                    </div>
                    <div style={{ overflowX:'auto', marginBottom:16 }}>
                      <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
                        <thead>
                          <tr>
                            {Object.keys(importPreview[0]).map(k => (
                              <th key={k} style={{ padding:'6px 10px', background:'#0f172a', color:'#38bdf8', textAlign:'left', whiteSpace:'nowrap' }}>{k}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {importPreview.map((row, i) => (
                            <tr key={i} style={{ borderBottom:'1px solid #0f172a' }}>
                              {Object.values(row).map((v: any, j) => (
                                <td key={j} style={{ padding:'6px 10px', color:'#e2e8f0', whiteSpace:'nowrap' }}>{v}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
                      <button onClick={() => { setImportModal(false); setImportResult(null); }}
                        style={{ background:'#334155', border:'none', color:'#94a3b8', padding:'10px 18px', borderRadius:8, cursor:'pointer', fontWeight:600 }}>Cancelar</button>
                      <button onClick={ejecutarImport} disabled={importando}
                        style={{ background:'#22c55e', border:'none', color:'white', padding:'10px 20px', borderRadius:8, cursor:'pointer', fontWeight:700, opacity: importando ? 0.7 : 1 }}>
                        {importando ? 'Importando...' : `Importar ${importPreview.length} clientes`}
                      </button>
                    </div>
                  </>
                ) : (
                  <div style={{ color:'#64748b', textAlign:'center', padding:20 }}>Selecciona un archivo CSV</div>
                )}
              </>
            ) : (
              <div>
                <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
                  {[
                    { label:'Importados', value: importResult.importados, color:'#22c55e' },
                    { label:'Duplicados (omitidos)', value: importResult.duplicados, color:'#f59e0b' },
                    { label:'Errores', value: importResult.errores?.length || 0, color:'#ef4444' },
                  ].map(s => (
                    <div key={s.label} style={{ background:'#0f172a', borderRadius:8, padding:14, textAlign:'center' }}>
                      <div style={{ fontSize:28, fontWeight:800, color:s.color }}>{s.value}</div>
                      <div style={{ color:'#64748b', fontSize:12 }}>{s.label}</div>
                    </div>
                  ))}
                </div>
                {importResult.errores?.length > 0 && (
                  <div style={{ background:'#ef444411', border:'1px solid #ef444433', borderRadius:8, padding:12, marginBottom:16 }}>
                    <div style={{ color:'#ef4444', fontWeight:700, fontSize:13, marginBottom:8 }}>Errores:</div>
                    {importResult.errores.map((e: string, i: number) => (
                      <div key={i} style={{ color:'#fca5a5', fontSize:12, marginBottom:4 }}>• {e}</div>
                    ))}
                  </div>
                )}
                <button onClick={() => { setImportModal(false); setImportResult(null); }}
                  style={{ background:'#0ea5e9', border:'none', color:'white', padding:'10px 24px', borderRadius:8, cursor:'pointer', fontWeight:700, width:'100%' }}>
                  Cerrar
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Lightbox foto */}
      {lightbox && (
        <div onClick={() => setLightbox(null)}
          style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.92)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:10000, padding:24, cursor:'zoom-out' }}>
          <img src={lightbox} alt="" style={{ maxWidth:'100%', maxHeight:'100%', objectFit:'contain', borderRadius:8 }} />
          <button onClick={() => setLightbox(null)}
            style={{ position:'absolute', top:16, right:20, background:'#1e293b', border:'1px solid #334155', color:'#fff', borderRadius:8, width:40, height:40, fontSize:18, cursor:'pointer' }}>✕</button>
        </div>
      )}
    </div>
  );
};

export default Clientes;
